import axios from 'axios';
import { baseURL } from './api';

const apiVersion = 'v2';
const path = process.env.REACT_APP_BASE_URL + `/api/${apiVersion}`;

class Inteliquent {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, baseURLOverride) {
    this.api = api;
    this.baseURL = baseURLOverride;
  }

  getPaginateOptions = paginationOptions => {
    return JSON.stringify(paginationOptions || { page: 1, limit: 10 });
  };

  getBaseURL = () => {
    return (this.baseURL || Inteliquent.resourcePath || Inteliquent.baseURL) + '/inteliquent';
  };

  async portInOrderList(body, paginationOptions) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data: resp } = await axios.post(`${this.getBaseURL()}/portInOrderList/?paginateOptions=${this.getPaginateOptions(paginationOptions)}`, body, {
      headers,
    });

    switch (resp.statusCode) {
      case '200':
        return resp;

      case '430':
        return { ...resp, orderList: [] };
    }

    throw resp;
  }

  async getPortInAvailability(body) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data: resp } = await axios.post(`${this.getBaseURL()}/portInAvailability`, body, {
      headers,
    });

    switch (resp.statusCode) {
      case '200':
        return resp;
    }

    throw resp;
  }

  async getOrderDetail(body) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data: resp } = await axios.post(`${this.getBaseURL()}/orderDetail`, body, {
      headers,
    });

    switch (resp.statusCode) {
      case '200':
        return resp;
    }

    throw resp;
  }

  async getOrderDocument(body) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data: resp } = await axios.post(`${this.getBaseURL()}/orderDocument`, body, {
      headers,
    });

    switch (resp.statusCode) {
      case '200':
        return resp;

      case '430':
        return { ...resp, orderDocumentList: { orderDocument: [] } };
    }

    throw resp;
  }

  async createPortInOrder(body, note, files) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
  
    const formdata = new FormData();
    formdata.append('portInOrder', JSON.stringify(body));
  
    if (note) formdata.append('note', note);
    
    if (files?.length) {
      files.forEach((file, index) => formdata.append(`files[${index}]`, file.file[0]));
    }
  
    const { data } = await axios.post(`${this.getBaseURL()}/portInOrder`, formdata, { headers });
  
    return data || {};
  }

  async updatePortInOrder(body, note, files) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const formdata = new FormData();
    formdata.append('orderUpdate', JSON.stringify(body));
    if (note) formdata.append('note', note);
    if (files?.length)
      files.forEach((file, index) => formdata.append(`files[${index}]`, file.file[0]));
    const { data: resp } = await axios.put(`${this.getBaseURL()}/pendingOrderUpdate`, formdata, {
      headers,
    });

    switch (resp.statusCode) {
      case '200':
        return resp;
    }

    throw resp;
  }

  async activatePortInOrder(body) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data: resp } = await axios.post(`${this.getBaseURL()}/activatePortInOrder`, body, {
      headers,
    });
    return resp;
  }

  async cancelPendingOrder(body) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data: resp } = await axios.post(`${this.getBaseURL()}/cancelPendingOrder`, body, {
      headers,
    });
    return resp;
  }

  async getTrunkGroupList() {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data: resp } = await axios.post(`${this.getBaseURL()}/trunkGroupList`, null, {
      headers,
    });
    return resp;
  }
}
export default Inteliquent;
